export const SEARCH_TERMS = ["question"];
export const inputFields = {
  question: {
    type: "string",
    required: true,
    title: "Question",
  },
  answer: {
    type: "html",
    required: false,
    title: "Answer",
  },
};
export const initialValues = {
  question: "",
  answer: "",
};

export const view_all_table = [{ name: "Question", value: "question" }];
